function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { clamp, find, groupBy, pathOr, pluck, propEq, propOr } from 'ramda';
import { i18n } from 'invision-core';
import { CurrentCustomerIdSelector } from '../../../../../reducers/selectors/customer.selectors';
import { CompletedDecisionsSelector, DecisionsRequiringAffectedServicesResolutionMappedForSelectedPageSelector, PagesIsFetchingDecisionOptionServiceIdsSelector } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { retrieveDecisionOptionServiceIds } from '../../../../../reducers/actions/edit.offer.wizard.actions';
import CustomerCareLocaleKeys from '../../../../../locales/keys';
var SelectAffectedServicesController = /*#__PURE__*/function () {
  function SelectAffectedServicesController($ngRedux, hotkeys) {
    _classCallCheck(this, SelectAffectedServicesController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      hotkeys: hotkeys
    });
  }
  return _createClass(SelectAffectedServicesController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          completedDecisions: CompletedDecisionsSelector(store),
          currentCustomerId: CurrentCustomerIdSelector(store),
          decisionsRequiringAffectedServicesResolution: DecisionsRequiringAffectedServicesResolutionMappedForSelectedPageSelector(store),
          isLoading: PagesIsFetchingDecisionOptionServiceIdsSelector(store)
        };
      };
      var controllerActions = {
        retrieveDecisionOptionServiceIds: retrieveDecisionOptionServiceIds
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.CustomerCareLocaleKeys = CustomerCareLocaleKeys;
      var formDynamicErrorTranslations = {
        additionalSelections: i18n.translate(this.CustomerCareLocaleKeys.DECISIONS.ADDITIONAL_SELECTIONS),
        requires: i18n.translate(this.CustomerCareLocaleKeys.DECISIONS.REQUIRES)
      };
      this.decisionOptionIds = [];
      this.formDynamicErrors = [];
      this.decisionsRequiringAffectedServicesResolutionForEdit = [];
      this.state.decisionsRequiringAffectedServicesResolution.forEach(function (decision) {
        _this.decisionOptionIds = _this.decisionOptionIds.concat(pluck('Id', decision.Options));
      });
      this.actions.retrieveDecisionOptionServiceIds(this.state.currentCustomerId, this.decisionOptionIds, this.offeringInstanceId).then(function (response) {
        var serviceIdsGroupedByDecisionOption = groupBy(function (decisionOptionServiceId) {
          return decisionOptionServiceId.DecisionOptionId;
        }, response.DecisionServiceIdentifiers);
        var updatedDecisionsRequiringAffectedServicesResolutionForEdit = [];
        _this.state.decisionsRequiringAffectedServicesResolution.forEach(function (decision) {
          var decisionWithOptionServiceIds = Object.assign({}, decision, {
            Options: decision.Options.map(function (option) {
              var decisionOptionPreviouslyCompletedDecision = _this.state.completedDecisions.find(function (completedDecision) {
                return completedDecision.SelectedValue === option.Id;
              });
              var decisionOptionServicesSelectedForRemoval = pathOr([], ['SelectedServicesForRemoval'], decisionOptionPreviouslyCompletedDecision);
              var decisionOptionServiceIds = serviceIdsGroupedByDecisionOption[option.Id].reduce(function (accumulatedServiceIds, decisionOptionServiceId) {
                var serviceIds = decisionOptionServiceId.ServiceIdentifiers.map(function (serviceId) {
                  var serviceIdIsSelected = false;
                  if (decisionOptionServicesSelectedForRemoval.length < option.numRequiredSelections) {
                    serviceIdIsSelected = decisionOptionServicesSelectedForRemoval.some(function (serviceSelectedForRemoval) {
                      return serviceSelectedForRemoval.ServiceAttributeId === serviceId.ServiceAttributeId && serviceSelectedForRemoval.Value === serviceId.Value;
                    });
                  }
                  return {
                    attributeId: serviceId.ServiceAttributeId,
                    disabled: false,
                    Id: serviceId.Value,
                    Name: serviceId.FriendlyName || serviceId.Value,
                    selected: serviceIdIsSelected
                  };
                });
                return accumulatedServiceIds.concat(serviceIds);
              }, []);
              return Object.assign({}, option, {
                serviceIdentifiers: decisionOptionServiceIds
              });
            })
          });
          updatedDecisionsRequiringAffectedServicesResolutionForEdit.push(decisionWithOptionServiceIds);
        });
        _this.decisionsRequiringAffectedServicesResolutionForEdit = updatedDecisionsRequiringAffectedServicesResolutionForEdit;
      });
      this.hotkeys.add({
        callback: function callback(event) {
          event.preventDefault();
          _this.handleFormSubmit();
        },
        combo: 'enter'
      });
      this.hotkeys.add({
        callback: function callback(event) {
          event.preventDefault();
          _this.handleClose();
        },
        combo: 'esc'
      });
      this.handleClose = function () {
        _this.onClose()();
      };
      this.handleFormSubmit = function () {
        var selectedDecisionOptionServiceIds = [];
        _this.formDynamicErrors = [];
        _this.decisionsRequiringAffectedServicesResolutionForEdit.forEach(function (decision) {
          decision.Options.forEach(function (option) {
            var numOptionRemainingSelections = _this.getNumDecisionOptionRemainingSelections(option);
            if (0 !== numOptionRemainingSelections) {
              _this.formDynamicErrors.push("\"".concat(option.Name, "\" ").concat(formDynamicErrorTranslations.requires, " ").concat(numOptionRemainingSelections, " ").concat(formDynamicErrorTranslations.additionalSelections));
            } else {
              selectedDecisionOptionServiceIds.push({
                decisionId: decision.Id,
                optionId: option.Id,
                serviceIdentifiers: _this.getSelections(option.serviceIdentifiers),
                updatedQuantity: option.updatedQuantity
              });
            }
          });
        });
        if (0 === _this.formDynamicErrors.length) {
          _this.onSuccess()(selectedDecisionOptionServiceIds);
        }
      };
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.hotkeys.del('enter');
      this.hotkeys.del('esc');
      this.disconnectRedux();
    }
  }, {
    key: "getNumDecisionOptionCurrentSelections",
    value: function getNumDecisionOptionCurrentSelections(option) {
      return this.getNumSelections(option.serviceIdentifiers);
    }
  }, {
    key: "getNumDecisionOptionRemainingSelections",
    value: function getNumDecisionOptionRemainingSelections(option) {
      return this.getNumDecisionOptionRequiredSelections(option) - this.getNumDecisionOptionCurrentSelections(option);
    }
  }, {
    key: "getNumDecisionOptionRequiredSelections",
    value: function getNumDecisionOptionRequiredSelections(option) {
      return option.numRequiredSelections;
    }
  }, {
    key: "getNumSelections",
    value: function getNumSelections() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.getSelections(options).length;
    }
  }, {
    key: "getSelections",
    value: function getSelections() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return options.filter(function (option) {
        return option.selected;
      });
    }
  }, {
    key: "toggleSelection",
    value: function toggleSelection(decisionId, optionId, serviceIdentifierId) {
      var _this2 = this;
      this.decisionsRequiringAffectedServicesResolutionForEdit.forEach(function (decision) {
        if (decisionId === decision.Id) {
          decision.Options.forEach(function (option) {
            if (optionId === option.Id) {
              var serviceIdentifierIsCurrentlySelected = propOr(false, 'selected', find(propEq(serviceIdentifierId, 'Id'), option.serviceIdentifiers));
              var numOptionRemainingSelections = _this2.getNumDecisionOptionRemainingSelections(option);
              var numOptionRemainingSelectionsAfterToggle = clamp(0, option.numRequiredSelections, serviceIdentifierIsCurrentlySelected ? numOptionRemainingSelections + 1 : numOptionRemainingSelections - 1);
              if (serviceIdentifierIsCurrentlySelected || numOptionRemainingSelections > 0) {
                option.serviceIdentifiers.forEach(function (serviceIdentifier) {
                  if (serviceIdentifierId === serviceIdentifier.Id) {
                    serviceIdentifier.disabled = false;
                    serviceIdentifier.selected = !serviceIdentifierIsCurrentlySelected;
                  } else {
                    serviceIdentifier.disabled = !serviceIdentifier.selected && 0 === numOptionRemainingSelectionsAfterToggle;
                  }
                });
              }
            }
          });
        }
      });
      return false;
    }
  }]);
}();
export default {
  template: require('./select.affected.services.popup.html'),
  bindings: {
    config: '<',
    offeringInstanceId: '<',
    onClose: '&',
    onSuccess: '&'
  },
  controllerAs: 'selectAffectedServicesController',
  controller: SelectAffectedServicesController
};